
export const typesoflanguage = [
    {
        id: 1,
        img:"https://imgr.search.brave.com/FsN6hnmX__z6c1VCNkSa-XNPrmb-hnMrVmE0jXFvNGs/fit/474/225/ce/1/aHR0cHM6Ly90c2U0/Lm1tLmJpbmcubmV0/L3RoP2lkPU9JUC5D/NFNjY3ZPRFl2NFNC/eXBKRm1ZQUV3SGFI/YSZwaWQ9QXBp",
    },
    {
        id: 2,
        img:"https://imgr.search.brave.com/nb5a6VsZLnYYvE9gN3xyekFv0ydSx1iM9_PPBmANeEY/fit/461/225/ce/1/aHR0cHM6Ly90c2Uz/Lm1tLmJpbmcubmV0/L3RoP2lkPU9JUC5w/cWNQc2tWZFRySnFm/aFotWjQ5QXRRSGFI/biZwaWQ9QXBp",
    },
    {
        id: 3,
        img:"https://imgr.search.brave.com/bEbwiwJa0C0IUv4Csn6AbZIi92WPl-UaE7IEd3TYaww/fit/474/225/ce/1/aHR0cHM6Ly90c2U0/Lm1tLmJpbmcubmV0/L3RoP2lkPU9JUC55/VUliNVNfa2o5OEVn/NXRULU9ueDFBSGFI/YSZwaWQ9QXBp",
    },
    {
        id: 4,
        img:"https://imgr.search.brave.com/FuKeHEMLNAnVP5gxDGUGy6tyP3CmqHRoGBWVPkLlzPo/fit/474/225/ce/1/aHR0cHM6Ly90c2Uy/Lm1tLmJpbmcubmV0/L3RoP2lkPU9JUC42/OGpseDV3Q2IwSlRm/emVTN0lhaXFnSGFI/YSZwaWQ9QXBp",
    },
    {
        id: 5,
        img:"https://imgr.search.brave.com/tWAEwBsoPFSFIp1DXXC689WoIt_SHjmJiDl0-eYAKQM/fit/474/225/ce/1/aHR0cHM6Ly90c2Ux/Lm1tLmJpbmcubmV0/L3RoP2lkPU9JUC41/dGdqWXZVTUpzR3c1/aGhybWVHT1BBSGFI/YSZwaWQ9QXBp",
    },
    {
        id: 6,
        img:"https://imgr.search.brave.com/ZcCalt1LG0pVAjvBZfK8sNJ_KM0o11Hciyt2-wK4RyI/fit/474/225/ce/1/aHR0cHM6Ly90c2Uz/Lm1tLmJpbmcubmV0/L3RoP2lkPU9JUC52/ZG5id2hzYWs3M0NI/cHkxMTNManZ3SGFI/YSZwaWQ9QXBp",
    },
    {
        id: 7,
        img:"https://imgr.search.brave.com/_x9TRBwX24gIivoqSF3HhDdn0Cte9EwibOD7p0WGc1Q/fit/564/225/ce/1/aHR0cHM6Ly90c2Uz/Lm1tLmJpbmcubmV0/L3RoP2lkPU9JUC5j/NFJCSXlUSGFlUkgw/OFQ0YnBfd2FBSGFH/TyZwaWQ9QXBp",
    },
    {
        id: 8,
        img:"https://imgr.search.brave.com/rtuDd5bIfKGflGjrkkkMP8LuxtO9jLblcA0TY-pvSaM/fit/474/225/ce/1/aHR0cHM6Ly90c2Uy/Lm1tLmJpbmcubmV0/L3RoP2lkPU9JUC5B/bkhTeHVOWkZzeVRt/WmxKaHV0YVpBSGFI/YSZwaWQ9QXBp",
    },
] 
